// extracted by mini-css-extract-plugin
module.exports = {"lia-version-number":"MessageVersionHistory_lia-version-number__eJnUC"};